import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { useGetDefectIndicatorData } from 'business/quality-control/pages/record-segment-defect/hooks/data/get-defect-indicator';
import { DefectType } from 'business/quality-control/pages/ring-compliance-report-detail/components/ring-compliance-body/types';
import { DefectsDetailDto } from 'generated/apiSchemas';

import { CardDetails } from './card-details';
import styles from './index.module.scss';

export const DefectDetails = ({ data }: { data: DefectsDetailDto }) => {
  const { t } = useTranslation();
  const { currentConstructionSiteId } = useAppContext();
  invariant(currentConstructionSiteId, 'No construction site id');

  const { hasIndicators } = useGetDefectIndicatorData(
    currentConstructionSiteId,
  );

  const labelType =
    data.defectType === DefectType.Quarantine
      ? t(
          'qualityControl.ringComplianceReport.detail.body.defectType.quarantine',
        )
      : t('qualityControl.ringComplianceReport.detail.body.defectType.tunnel');

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.headerLabel}>{labelType}</span>
        <div className={styles.badge}>
          <span>:</span>
          <span>{data.defectTypeLabel}</span>
          {data.defectTypeColor && (
            <span
              className={styles.dot}
              style={{ backgroundColor: data.defectTypeColor }}
            />
          )}
        </div>
      </div>
      <div className={styles.body}>
        <CardDetails
          title={t(
            'qualityControl.ringComplianceReport.detail.body.declaration',
          )}
          date={data.declaration.date}
          author={data.declaration.author}
          comment={data.declaration.comment}
          toRepair={data.declaration.toRepair}
          indicator={
            hasIndicators && data.defectType === DefectType.Tunnel
              ? data.declaration.indicator
              : undefined
          }
          hasBorder={data.repair !== null}
        />
        {data.repair && (
          <CardDetails
            title={t('qualityControl.ringComplianceReport.detail.body.repair')}
            date={data.repair.date}
            author={data.repair.author}
            comment={data.repair.comment}
          />
        )}
      </div>
    </div>
  );
};
